import { Badge, Body1, BrandGraphic, Card, Title3, XStack, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { type OnDone, tagged } from "../../lib/flow-engine";
export type FinancialAssistanceOutcomes = {
  continue: {};
  back: {};
};
const Outcome = tagged<FinancialAssistanceOutcomes>();
export function FinancialAssistance({
  onDone
}: {
  onDone: OnDone<FinancialAssistanceOutcomes>;
}) {
  return <OnboardingScreen data-sentry-element="OnboardingScreen" data-sentry-component="FinancialAssistance" data-sentry-source-file="FinancialAssistance.tsx">
      <OnboardingScreen.Nav onBackPress={() => onDone(Outcome.back())} showLogo={false} data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="FinancialAssistance.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="FinancialAssistance.tsx">
        <OnboardingScreen.Header alignment="left" title="Many people qualify for income-based discounts" subtitle="Answer a few questions to see if you're eligible." data-sentry-element="OnboardingScreen.Header" data-sentry-source-file="FinancialAssistance.tsx" />
        <Card variant="elevated" size="large" data-sentry-element="Card" data-sentry-source-file="FinancialAssistance.tsx">
          <YStack gap="$sp1.5" data-sentry-element="YStack" data-sentry-source-file="FinancialAssistance.tsx">
            <XStack justifyContent="space-between" alignItems="flex-start" gap="$sp2" data-sentry-element="XStack" data-sentry-source-file="FinancialAssistance.tsx">
              <YStack gap="$sp1" alignItems="flex-start" flexShrink={1} data-sentry-element="YStack" data-sentry-source-file="FinancialAssistance.tsx">
                <Badge status="positive" size="small" data-sentry-element="Badge" data-sentry-source-file="FinancialAssistance.tsx">
                  The Granted Difference
                </Badge>
                <Title3 data-sentry-element="Title3" data-sentry-source-file="FinancialAssistance.tsx">$1,800-$8,400</Title3>
              </YStack>
              <BrandGraphic type="bill" indicator="dollar" size="$si7" data-sentry-element="BrandGraphic" data-sentry-source-file="FinancialAssistance.tsx" />
            </XStack>
            <Body1 color="$textSubtle" data-sentry-element="Body1" data-sentry-source-file="FinancialAssistance.tsx">
              Average income-based discounts for Granted users
            </Body1>
          </YStack>
        </Card>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="FinancialAssistance.tsx">
        <OnboardingScreen.PrimaryAction testID="fa-intro.continue" variant="brand" onPress={() => onDone(Outcome.continue())} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="FinancialAssistance.tsx">
          See if I qualify
        </OnboardingScreen.PrimaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}